import {createContext} from 'react';

export type UploadAttendeeFromContactsContextType = {
	searchColumn: string;
	setSearchColumn: (prop: string) => void;
};

export const UploadAttendeeFromContactsContext = createContext({} as UploadAttendeeFromContactsContextType);
